export const API_ENDPOINTS = {
  health: '/health',
  auth: {
    login: '/auth/business/login',
    platformLogin: '/auth/platform/login',
    register: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    changePassword: '/auth/change-password',
    me: '/auth/me',
    refresh: '/auth/refresh-token',
    logout: '/auth/logout',
  },
  tenants: {
    base: '/tenants',
    register: '/tenants/register',
    beginOnboarding: '/tenants/onboarding/start',
    completeAccount: '/tenants/onboarding/complete-account',
    entitlements: (tenantId: string) => `/tenants/${tenantId}/entitlements`,
    approval: (tenantId: string) => `/tenants/${tenantId}/approval`,
    myStatus: '/tenants/me/status',
    resubmitMine: '/tenants/me/resubmit',
    internalBusinesses: '/tenants/internal-businesses',
  },
  subscriptionPlans: {
    base: '/subscription-plans',
    byTenant: (tenantId: string) => `/subscription-plans/tenants/${tenantId}`,
    me: '/subscription-plans/me',
    selectMine: '/subscription-plans/me/select',
  },
  dashboard: '/dashboard',
  users: '/users',
  roles: '/roles',
  permissions: '/permissions',
  products: {
    base: '/products',
    me: '/products/me',
    myUsed: '/products/me/used',
    categories: '/products/categories',
    categoryChildren: (categoryId: string) => `/products/categories/${categoryId}/children`,
    brands: '/products/brands',
    adminCategories: '/admin/products/categories',
    adminBrands: '/admin/products/brands',
    reviewQueue: '/admin/products/review',
    reviewCounts: '/admin/products/review/counts',
    reviewDetail: (productId: string) => `/admin/products/${productId}/review`,
    moderate: (productId: string) => `/admin/products/${productId}/moderation`,
    categoryProfitRules: (categoryId: string) =>
      `/admin/products/categories/${categoryId}/profit-rules`,
    profitRule: (ruleId: string) => `/admin/products/profit-rules/${ruleId}`,
  },
  orders: {
    base: '/orders',
    me: '/orders/me',
    sales: '/orders/sales',
    mySales: '/orders/sales/me',
    fromCart: '/orders/from-cart',
  },
  chats: {
    conversations: '/chats/conversations',
    myConversations: '/chats/conversations/me',
  },
  notifications: {
    base: '/notifications',
    me: '/notifications/me',
    test: '/notifications/test',
    deviceTokens: '/notifications/device-tokens',
  },
  business: {
    types: '/business-types',
    onboard: '/businesses/onboard',
    onboardWithDocuments: '/businesses/onboard-with-documents',
    me: '/businesses/me',
    adminByTenant: (tenantId: string) => `/businesses/admin/tenant/${tenantId}`,
    locations: '/businesses/me/locations',
    subscription: '/businesses/me/subscription',
    adminLocations: '/admin/business-locations',
    tenantLocations: (tenantId: string) => `/admin/business-locations/tenant/${tenantId}`,
  },
  customers: {
    admin: '/customers/admin',
    lookup: '/customers/admin/lookup',
    createIdentity: '/customer/auth/admin/phone-customer',
    aadhaarOtp: (customerUserId: string) =>
      `/customers/admin/${customerUserId}/identity-verification/aadhaar/otp`,
    aadhaarVerify: (customerUserId: string) =>
      `/customers/admin/${customerUserId}/identity-verification/aadhaar/verify`,
  },
  appContent: {
    public: '/app-content',
    admin: '/app-content/admin',
    all: '/app-content/admin/all',
    byId: (id: string) => `/app-content/admin/${id}`,
    verificationOffer: '/app-content/seller-verification-offer',
    adminVerificationOffer: '/app-content/admin/seller-verification-offer',
  },
  supportTickets: {
    admin: '/support-tickets/admin',
    byId: (id: string) => `/support-tickets/admin/${id}`,
  },
  faqs: {
    public: '/faqs',
    admin: '/faqs/admin',
    byId: (id: string) => `/faqs/admin/${id}`,
  },
  locations: {
    autocomplete: '/third-party/locations/autocomplete',
    placeDetails: '/third-party/locations/details',
    geocode: '/third-party/locations/geocode',
    reverseGeocode: '/third-party/locations/reverse-geocode',
  },
} as const;
